export default "__VITE_ASSET__Dp_Hd1YA__"